import { render, staticRenderFns } from "./BannerRecalculation.vue?vue&type=template&id=f3c4897e&scoped=true&lang=pug"
import script from "./BannerRecalculation.vue?vue&type=script&lang=js"
export * from "./BannerRecalculation.vue?vue&type=script&lang=js"
import style0 from "./BannerRecalculation.vue?vue&type=style&index=0&id=f3c4897e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c4897e",
  null
  
)

export default component.exports